'use strict';

if (process.env.NODE_ENV === "production") {
  module.exports = require("./emotion-is-prop-valid.cjs.prod.js");
} else {
  module.exports = require("./emotion-is-prop-valid.cjs.dev.js");
}



//////////////////
// WEBPACK FOOTER
// ./~/@emotion/is-prop-valid/dist/emotion-is-prop-valid.cjs.js
// module id = 365
// module chunks = 0